import { MenuItem, Typography } from "@mui/material";
import { PlatformFeeSchedule } from "protogen/billing_pb";
import { feeSchedule } from "./utils";
import Select from "components/common/Select";

type Props = {
  value?: PlatformFeeSchedule;
  onUpdate: (p?: PlatformFeeSchedule) => void;
  disabled?: boolean;
  fullWidth?: boolean;
};

export default ({
  value,
  onUpdate,
  disabled = false,
  fullWidth = false,
}: Props) => {
  const toMenuItem = (
    name: string,
    description: string,
    val: PlatformFeeSchedule,
  ) => (
    <MenuItem key={name} value={val}>
      <div>
        <Typography
          variant="subtitle1"
          sx={{
            textWrap: "nowrap",
            textOverflow: "ellipsis",
            overflowX: "hidden",
          }}
        >
          {name}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            textWrap: "nowrap",
            textOverflow: "ellipsis",
            overflowX: "hidden",
          }}
        >
          {description}
        </Typography>
      </div>
    </MenuItem>
  );
  return (
    <Select
      variant="outlined"
      placeholder="Platform fee"
      displayEmpty
      value={value || ""}
      disabled={disabled}
      onChange={(e) => {
        const val = e.target.value as PlatformFeeSchedule;
        onUpdate(val || undefined);
      }}
      sx={{
        "& .MuiInputBase-input": {
          marginTop: "0px !important",
        },
        width: fullWidth ? "100%" : "calc(33% - 8px)",
        height: "60px",
      }}
    >
      <MenuItem key={""} value={""} disabled>
        Platform fee
      </MenuItem>
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_LEAD_GEN_35_35_35_20),
        "Standard fee for generated lead.",
        PlatformFeeSchedule.SCHEDULE_LEAD_GEN_35_35_35_20,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_LEAD_GEN_30_30_30_10),
        "Legacy (V1) fee for generated lead.",
        PlatformFeeSchedule.SCHEDULE_LEAD_GEN_30_30_30_10,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_FLAT_10),
        "A flat 10% fee.",
        PlatformFeeSchedule.SCHEDULE_FLAT_10,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_LEAD_GEN_30_30_30_15),
        "Legacy (V0) fee for generated lead.",
        PlatformFeeSchedule.SCHEDULE_LEAD_GEN_30_30_30_15,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_FLAT_15),
        "A flat 15% fee.",
        PlatformFeeSchedule.SCHEDULE_FLAT_15,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_FLAT_20),
        "A flat 20% fee.",
        PlatformFeeSchedule.SCHEDULE_FLAT_20,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_NO_FEE),
        "No faye fee for this client.",
        PlatformFeeSchedule.SCHEDULE_NO_FEE,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_LEAD_GEN_43_43_43_30),
        "Experimental fee for generated lead.",
        PlatformFeeSchedule.SCHEDULE_LEAD_GEN_43_43_43_30,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_LEAD_GEN_45_45_45_25),
        "2026 standard fee for generated lead.",
        PlatformFeeSchedule.SCHEDULE_LEAD_GEN_45_45_45_25,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_FLAT_25),
        "A flat 25% fee.",
        PlatformFeeSchedule.SCHEDULE_FLAT_25,
      )}
      {toMenuItem(
        feeSchedule(PlatformFeeSchedule.SCHEDULE_ADVISOR_DISCOUNT_35_15),
        "Advisor sponsored 20% discount - 35% / 15%",
        PlatformFeeSchedule.SCHEDULE_ADVISOR_DISCOUNT_35_15,
      )}
    </Select>
  );
};
